import { REHYDRATE } from "redux-persist";
import { ANY_FIELD_UPDATE, updatedObject } from "../actions/formActions";

import {
    NOTIFICATION_SETTING_INIT,
    NOTIFICATION_SETTING_FETCH_BEGIN,
    NOTIFICATION_SETTING_FETCH_SUCCESS,
    NOTIFICATION_SETTING_FETCH_FAIL,
    NOTIFICATION_SETTING_UPDATE_BEGIN,
    NOTIFICATION_SETTING_UPDATE_SUCCESS,
    NOTIFICATION_SETTING_UPDATE_FAIL,
} from "../actions/notificationSettingAction";

import { LOGOUT } from "../actions/loginStateActions";

const INITIAL_STATE = {
    data: {
        isActive: false,
        name: ""
    },
    status: "uninitialized"
}

export default function notificationSettingReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;
            case NOTIFICATION_SETTING_INIT:
            return { data: INITIAL_STATE.data, status: "editing" };

        case NOTIFICATION_SETTING_FETCH_BEGIN:
            return { data: {}, status: "fetching" };

        case NOTIFICATION_SETTING_FETCH_SUCCESS:
            return {
                data: {
                    ...action.data,
                },
                status: "viewing",
            };

        case NOTIFICATION_SETTING_FETCH_FAIL:
            return { data: {}, status: "failed", failReason: action.reason };

        case NOTIFICATION_SETTING_UPDATE_BEGIN:
            return { data: { ...state.data }, status: "fetching" };

        case NOTIFICATION_SETTING_UPDATE_SUCCESS:
            return {
                data: {
                    ...action.data,
                },
                status: "fetching",
            };

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== "notificationSetting") return state;

            return {
                ...state,
                data: updatedObject(state.data, action.accessPath, action.newVal),
            };
        }

        case NOTIFICATION_SETTING_UPDATE_FAIL:
            return { data: { ...state.data }, status: "fetching", failReason: action.reason };

        case LOGOUT:
            return { data: {}, status: "uninitialized" };

        default:
            return state;
    }
}